import { render, staticRenderFns } from "./SocSelector.vue?vue&type=template&id=47e7553e&scoped=true"
import script from "./SocSelector.vue?vue&type=script&lang=js"
export * from "./SocSelector.vue?vue&type=script&lang=js"
import style0 from "./SocSelector.vue?vue&type=style&index=0&id=47e7553e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7553e",
  null
  
)

export default component.exports